import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"

export type FeatureCountrySkeletonProps = {
  className?: string
}

/**
 * The country section's shape while its two queries land: the explainer
 * line, the Save button, and a row per supported country.
 *
 * Three rows because that is how many countries the platform ships today —
 * a placeholder the same height as the answer, so the tab does not jump
 * under the operator's cursor when it arrives.
 */
function FeatureCountrySkeleton(props: FeatureCountrySkeletonProps) {
  const { className } = props

  return (
    <div className={cn("flex flex-col gap-3", className)} aria-busy="true">
      <div className="flex items-start gap-3">
        <Skeleton className="h-4 flex-1" />
        <Skeleton className="h-8 w-16 rounded-md" />
      </div>
      <div className="flex max-w-md flex-col gap-1.5">
        {[0, 1, 2].map((index) => (
          <div key={index} className="flex items-center gap-2">
            <Skeleton className="size-4 shrink-0 rounded-sm" />
            <Skeleton className="h-4 w-4 shrink-0 rounded-xs" />
            <Skeleton className="h-4 w-20" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default FeatureCountrySkeleton
